import { Component, OnInit } from '@angular/core';
import { ChangeDataService } from 'src/app/Services/ChangeData/changeData.service';
import { delay } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/Api/api.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-noticia',
  templateUrl: './noticia.component.html',
  styleUrls: ['./noticia.component.css'],
})
export class NoticiaComponent implements OnInit {
  public subcripcion?: Subscription;
  public content: any;
  public nombreNoticia: any;

  dataHeader = {
    classTitle: 'blue',
    title: 'Noticias de interés',
  };

  cardsData: any[] = [];
  constructor(
    private changeDataService: ChangeDataService,
    private _apiService: ApiService,
    private _activatedroute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.subcripcion = this._activatedroute.paramMap.subscribe((params) => {
      if (params.get('id')) {
        this._apiService
          .get('noticia/' + params.get('id'))
          .then((data: any) => {
            this.dataHeader.title = data.noticia.nombre;
            this._apiService
              .get('raw/1/' + data.noticia.rutaNoticia)
              .then((data: any) => {
                this.content = data.contenido;
              });
          });
      }
    });
  }
}
